var EHDI = EHDI || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.Sparkle = function() {
    EHDI.aka.Sprite.call(this,EHDI.Assets.images["fx_sparkle"]);

    var _this = this;
    
    this.scale.set(0, 0);
    this.anchor.set(0.5);
    this.alpha = 0;
    var _timeline = new TimelineMax({repeat : -1, yoyo: true, repeatDelay : 0.5});

    
    this.appear = function() {
        var randScale = Math.random() * 0.5 + 0.5;
        var randDur = Math.random() - 0.25;
        _timeline.to(_this.scale, randDur, {x : randScale, y : randScale});
        _timeline.to(_this, randDur, {alpha : 1});
    }
}

EHDI.components.Sparkle.prototype = Object.create(EHDI.aka.Sprite.prototype);